<template>
  <div class="c-target-wrap" :class="{ 'disabled-wrap': disabled }" v-if="show">
    <Spin size="large" fix v-if="!show" />

    <!-- 定向方式 -->
    <Row class="row-item" :gutter="12" v-if="!isUseAdUnion">
      <Col span="3" class="col-item">
        <span class="item-field">定向方式</span>
      </Col>
      <Col span="12">
        <RadioGroup v-model="target.intelli_extend_option" @on-change="onIntelliExtendChange" type="button">
          <Radio :label="0">自定义定向</Radio>
          <Radio :label="1">智能定向</Radio>
        </RadioGroup>
      </Col>
    </Row>

    <!-- 定向包名称 -->
    <Row class="row-item" :gutter="12">
      <Col span="3" class="col-item">
        <span class="item-field row-item-must">定向包名称</span>
      </Col>
      <Col span="12">
        <input-len :value="targetName" placeholder="最大20个字符，1个中文等于2个字符" width="480" :max="20" @change="changeTargetName" />
      </Col>
    </Row>
    <!-- 地域 -->
    <Row class="row-item" :gutter="12">
      <Col span="3" class="col-item">
        <span class="item-field">地域</span>
      </Col>
      <Col span="12">
        <RadioGroup v-model="target.district" type="button" @on-change="radioChange('cityData')">
          <Radio label="NONE">不限</Radio>
          <Radio label="CITY">按省市</Radio>
        </RadioGroup>
      </Col>
    </Row>
    <Row class="row-item" :gutter="12" v-show="target.district === 'CITY'">
      <Col span="3">&nbsp;</Col>
      <Col span="14">
        <selecter
          v-model="mult_city"
          :data="target.cityData"
          :title="['省份', '城市']"
          @on-select="selectAll"
          @on-delete="delTag"
          @on-clear="clearTag"
        />
      </Col>
    </Row>

    <!-- 性别 -->
    <Row class="row-item" :gutter="12">
      <Col span="3" class="col-item">
        <span class="item-field">性别</span>
      </Col>
      <Col span="12">
        <RadioGroup v-model="target.gender" type="button">
          <Radio :label="0">不限</Radio>
          <Radio :label="2">男</Radio>
          <Radio :label="1">女</Radio>
        </RadioGroup>
      </Col>
    </Row>

    <!-- 年龄 -->
    <Row class="row-item" :gutter="12">
      <Col span="3" class="col-item">
        <span class="item-field">年龄</span>
      </Col>
      <Col span="18">
        <RadioGroup v-model="target.ageMode" type="button">
          <Radio label="NONE">不限</Radio>
          <Radio label="CUSTOM">自定义年龄</Radio>
        </RadioGroup>
      </Col>
    </Row>
    <Row class="row-item" :gutter="12" v-if="target.ageMode === 'CUSTOM'">
      <Col span="3" class="col-item">
        <span class="item-field">&nbsp;</span>
      </Col>
      <Col span="18">
        <Slider v-model="target.age" :marks="marks" :step="1" :min="18" :max="75" style="width: 804px" range />
      </Col>
    </Row>

    <!-- 人群包 -->
    <Row class="row-item" :gutter="12">
      <Col span="3" class="col-item">
        <span class="item-field">人群包</span>
      </Col>
      <Col span="12">
        <RadioGroup v-model="target.audienceMode" type="button" @on-change="changeRetarget">
          <Radio label="NONE">不限</Radio>
          <Radio label="AUDIENCE">定向或排除人群</Radio>
        </RadioGroup>
      </Col>
    </Row>
    <Row class="row-item" :gutter="12" v-if="target.audienceMode === 'AUDIENCE'">
      <Col span="3">&nbsp;</Col>
      <Col span="17">
        <retarget
          title="选定人群"
          :data="target.audienceData"
          :pay-type-bag="payTypeBag"
          :accounts="accounts"
          :auto="Boolean(target.intelli_extend_option)"
          :curren-tab="Boolean(target.intelli_extend_option) ? 'exclude' : 'include'"
          @on-clear="clearRetarget"
          @on-change="changeTarget"
          @on-select-all="selectTargetAll"
          @on-delete="delRetarget"
        />
      </Col>
    </Row>
    <template v-if="!target.intelli_extend_option">
      <!-- 行为意向定向-->
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">行为意向定向</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="target.behavior_type" type="button" @on-change="resetInterestAction">
            <Radio :label="0">不限</Radio>
            <Radio :label="1">自定义</Radio>
            <!-- <Radio :label="2" :disabled="isUseAdUnion">系统优选</Radio> -->
          </RadioGroup>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12" v-if="target.behavior_type === 1">
        <Col span="3" class="col-item">
          <span class="item-field">行为</span>
        </Col>
        <Col span="15">
          <!-- 新版 -->
          <action-interest
            v-model="target.action_tags"
            :action-scene="target.action_scene"
            :action-days="target.action_days"
            :strength="target.action_intensity"
            :max="100"
            :accounts="accounts"
            action
            @on-days="setDays"
            @on-scene="setScene"
            @on-intensity="setIntensity('action_intensity', $event)"
          />
        </Col>
      </Row>
      <Row class="row-item" :gutter="12" v-if="target.behavior_type === 1">
        <Col span="3" class="col-item">
          <span class="item-field">意向</span>
        </Col>
        <Col span="15">
          <!-- 新版 -->
          <action-interest
            v-model="target.word_tags"
            :strength="target.interest_intensity"
            :accounts="accounts"
            :max="100"
            @on-intensity="setIntensity('interest_intensity', $event)"
          />
        </Col>
      </Row>
    </template>

    <Row class="row-item" :gutter="12">
      <Col span="3" class="col-item">
        <span class="item-field">操作系统版本</span>
      </Col>
      <Col span="12">
        <RadioGroup v-model="target.platform_os" type="button">
          <Radio :label="0" :disabled="isAndroid || isIOS">不限</Radio>
          <Radio :label="1" :disabled="isAndroid || isIOS">安卓</Radio>
          <Radio :label="2" :disabled="isAndroid || isIOS">iOS</Radio>
        </RadioGroup>
      </Col>
    </Row>

    <!-- 安卓版本 -->
    <Row class="row-item" :gutter="12" v-if="target.platform_os === 1">
      <Col span="3" class="col-item">
        <span class="item-field">安卓版本</span>
      </Col>
      <Col span="12">
        <version v-model="target.android_osv" :data="androidVersion" title="安卓版本" />
      </Col>
    </Row>
    <!-- iOS版本 -->
    <Row class="row-item" :gutter="12" v-if="target.platform_os === 2">
      <Col span="3" class="col-item">
        <span class="item-field">iOS版本</span>
      </Col>
      <Col span="12">
        <version v-model="target.ios_osv" :data="iOSVersion" title="iOS版本" />
      </Col>
    </Row>
    <template v-if="!target.intelli_extend_option">
      <!-- 设备品牌 -->
      <Row class="row-item" :gutter="12" v-if="isAndroid || isMiniGame">
        <Col span="3" class="col-item">
          <span class="item-field">设备品牌</span>
        </Col>
        <Col span="17">
          <Mixcheck v-model="target.device_brand_ids">
            <radio-item :label="0">不限</radio-item>
            <check-item v-for="item in deviceBrand" :key="item.id" :label="item.value">
              {{ item.label }}
            </check-item>
          </Mixcheck>
        </Col>
      </Row>

      <!-- 设备价格 -->
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">设备价格</span>
        </Col>
        <Col span="18">
          <Mixcheck v-model="target.device_price">
            <radio-item :label="0">不限</radio-item>
            <check-item v-for="item in devicePrice" :key="item.id" :label="item.value">
              {{ item.label }}
            </check-item>
          </Mixcheck>
        </Col>
      </Row>

      <!-- 网络 -->
      <Row class="row-item" :gutter="12">
        <Col span="3" class="col-item">
          <span class="item-field">网络</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="target.network" type="button">
            <Radio :label="0">不限</Radio>
            <Radio :label="1">WIFI</Radio>
            <Radio :label="2">移动网络</Radio>
          </RadioGroup>
        </Col>
      </Row>

      <!-- APP定向 -->
      <Row class="row-item" :gutter="12" v-show="isAndroid && !isUseAdUnion">
        <Col span="3" class="col-item">
          <span class="item-field">APP定向</span>
        </Col>
        <Col span="12">
          <RadioGroup v-model="target.app_behavior" type="button" @on-change="changeBehavior">
            <Radio :label="0">不限</Radio>
            <Radio :label="1">按APP分类</Radio>
            <Radio :label="2">按APP名称</Radio>
          </RadioGroup>
        </Col>
      </Row>
      <Row class="row-item" :gutter="12" v-if="isAndroid && target.app_behavior === 1 && !isUseAdUnion">
        <Col span="3">&nbsp;</Col>
        <Col span="17">
          <selecter
            v-model="mult_app"
            :data="target.appData"
            :title="['APP分类']"
            @on-select="selectAll"
            @on-delete="delTag"
            @on-clear="clearTag"
          />
        </Col>
      </Row>
      <Row class="row-item" :gutter="12" v-if="isAndroid && target.app_behavior === 2 && !isUseAdUnion">
        <Col span="3">&nbsp;</Col>
        <Col span="17">
          <adder
            v-model="target.mult_cate"
            :data="target.categroyData"
            :loading="cating"
            :maxtotal="10"
            :columns="adderCols"
            @on-select="selectCategroy"
            @on-search="getCategroy"
            @on-delete="delCategroy"
            @on-clear="clearCategroy"
            placeholder="请输入APP名称"
          />
        </Col>
      </Row>
    </template>

    <!-- 过滤已转化用户 -->
    <Row class="row-item" :gutter="12" v-show="!isUseAdUnion">
      <Col span="3" class="col-item">
        <span class="item-field">过滤已转化用户</span>
      </Col>
      <Col span="17">
        <Mixcheck v-model="target.filter_converted_level">
          <radio-item v-for="item in filterConvertLevel" :key="item.id" :disabled="isLink && item.label === 'APP'" :label="item.value">
            {{ item.label }}
          </radio-item>
        </Mixcheck>
      </Col>
    </Row>
  </div>
</template>

<script>
import mixin from '../../mixin'

import { getAppSearch } from '@/api/kuaishou.model'

import { clearTagOfData, getNameOfData, findCheck, isArray } from '@/common/js/utils'
import { marks, androidVersion, iOSVersion, iosDeviceBrand, deviceBrand, devicePrice, filterConvertLevel } from '@/data/kuaishou/datas'

import Selecter from '@/components/select/selecter.vue'
import Version from '@/components/version/'
import ActionInterest from '@/views/create/kuaishou_local/components/actioninterest/'
import Retarget from '../retarget'
import Adder from '@/components/add/adder'

export default {
  name: 'KuaishouTarget',
  mixins: [mixin],
  components: { Selecter, Version, ActionInterest, Retarget, Adder },
  props: {
    target: {
      type: Object
    },
    targetName: {
      type: String
    },
    show: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isUseAdUnion: {
      type: Boolean,
      default: false
    },
    isAndroid: {
      type: Boolean,
      default: false
    },
    isIOS: {
      type: Boolean,
      default: false
    },
    isMiniGame: {
      type: Boolean,
      default: false
    },
    isLink: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    mult_city() {
      return findCheck(this.target.cityData)
    },

    mult_app() {
      return findCheck(this.target.appData)
    },
    deviceBrand() {
      if (this.target.platform_os === 0) {
        return [...iosDeviceBrand, ...deviceBrand]
      }
      if (this.target.platform_os === 1) {
        return deviceBrand
      }
      if (this.target.platform_os === 2) {
        return iosDeviceBrand
      }
      return []
    }
  },
  watch: {
    isUseAdUnion() {
      this.$set(this.target, 'intelli_extend_option', 0)
      this.$set(this.target, 'behavior_type', 0) // 快手广告联盟不能系统优选，切换到不限
      this.$set(this.target, 'app_behavior', 0)
      this.$set(this.target, 'filter_converted_level', 0)
    }
  },
  data() {
    return {
      loading: null,
      cating: null, // 加载app名称
      marks, // 年龄标志
      androidVersion,
      iOSVersion,
      // deviceBrand,
      devicePrice,
      filterConvertLevel,
      adderCols: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          key: 'name',
          title: '名称'
        }
      ]
    }
  },
  methods: {
    /**
     * @description: 切换定向方式
     * @param {*} value 0 | 1
     */
    onIntelliExtendChange(value) {
      if (value) {
        // 行为意向类型切换到不限
        this.$set(this.target, 'behavior_type', 0)

        this.target.audienceData.forEach((item) => {
          item.select === 'include' && this.$set(item, 'select', null)
        })
      }
      this.$emit('type-change', value)
    },
    changeTargetName(val) {
      this.$emit('on-name', val)
    },
    changeBehavior() {
      this.radioChange('appData')
      this.target.categroyData = []
      this.target.mult_cate = []
    },
    getCategroy(keyword) {
      const params = { ad_account_id: this.account, appName: keyword }
      this.cating = true
      getAppSearch(params).then((data) => {
        this.cating = false
        if (data) {
          this.target.categroyData = data.map((ret) => {
            return {
              id: ret.app_id,
              name: ret.app_name
            }
          })
        }
      })
    },
    selectCategroy(val) {
      const app_ids = this.target.categroyData.map((ret) => ret.id)
      const noSourceItem = this.target.mult_cate.filter((ret) => !app_ids.includes(ret.id))
      noSourceItem.push(...val)
      this.target.mult_cate = noSourceItem
    },
    delCategroy(ids) {
      if (isArray(ids)) {
        ids.forEach((met) => {
          const index = this.target.mult_cate.findIndex((ret) => ret.id === met)
          if (index > -1) {
            this.target.mult_cate.splice(index, 1)
          }
        })
      }
    },
    clearCategroy() {
      this.target.mult_cate = []
    },
    setDays(val) {
      this.target.action_days = val
    },
    setScene(val) {
      this.target.action_scene = val
    },
    setIntensity(prop, val) {
      this.target[prop] = val
    },
    // 清空行为意向定向
    resetInterestAction() {
      this.target.action_scene = [1, 2, 4]
      this.target.action_days = 4
      this.target.action_intensity = 0
      this.target.interest_intensity = 0
      this.target.action_tags = []
      this.target.word_tags = []
    },
    // 清空人群包
    clearRetarget({ list }) {
      list.forEach((item) => {
        this.$set(item, 'select', null)
      })
    },
    changeTarget({ id, index, audienceData }) {
      if (!this.target.audiences[index].audienceData) {
        this.target.audiences[index].audienceData = audienceData
        this.target.audienceData = audienceData
      } else {
        this.target.audienceData = this.target.audiences[index].audienceData
      }
      this.$emit('ddd', this.target.audienceData)
    },
    delRetarget({ list, name }) {
      const index = list.findIndex((ret) => ret.name === name)
      if (index > -1) {
        this.$set(list[index], 'select', null)
      }
    },
    // 定向人群切换
    changeRetarget(val) {
      if (val === 'NONE') {
        this.target.audiences.forEach((ret) => {
          if (ret.audienceData && isArray(ret.audienceData)) {
            ret.audienceData.forEach((met) => {
              this.$set(met, 'select', '')
            })
          }
        })
      }
    },
    selectTargetAll({ type, check, index, checkList }) {
      const bool = Boolean(check)
      // const checkList = this.target.audiences[index].audienceData
      const includes = checkList.filter((ret) => ret.select === 'include')
      const excludes = checkList.filter((ret) => ret.select === 'exclude')
      const mutex = ({ type, code }) => {
        const isCodeSame = includes.some((ret) => ret.select && this.payTypeBag.includes(ret.type) && ret.code !== code)
        const isIncludesPayBag = includes.some((ret) => ret.select && this.payTypeBag.includes(ret.type) && !this.payTypeBag.includes(type))
        const isUnIncludesPayBag = includes.some(
          (ret) => ret.select && !this.payTypeBag.includes(ret.type) && this.payTypeBag.includes(type)
        )
        const isExcludes = excludes.some((ret) => ret.select && this.payTypeBag.includes(ret.type) && !this.payTypeBag.includes(type))
        const isUnExcludesPayBag = excludes.some((ret) => ret.select && this.payTypeBag.includes(type))
        return isIncludesPayBag || isUnIncludesPayBag || isExcludes || isUnExcludesPayBag || isCodeSame
      }
      if (isArray(checkList)) {
        checkList.forEach((ret) => {
          this.$set(ret, 'select', bool && !mutex(ret) ? type.substr(0, type.length - 1) : null)
        })
      }
    },
    radioChange(key) {
      clearTagOfData(this.target[key], this)
    },
    // 全选
    selectAll({ list, check = true, current = '' }) {
      let data
      if (current) {
        const item = getNameOfData(list, current)
        data = item.children
      } else data = list
      // 递归选中
      const deepSelectAll = (items) => {
        items.some((ret) => {
          if (ret.children && ret.children.length) deepSelectAll(ret.children)
          this.$set(ret, 'check', check)
        })
      }
      deepSelectAll(data)
    },
    // 删除已选
    delTag({ list, name }) {
      const data = getNameOfData(list, name)
      if (data.children && data.children.length) {
        this.selectAll({ list, check: false, current: data.value })
      } else {
        this.$set(data, 'check', false)
      }
    },
    // 清空全部
    clearTag({ list }) {
      clearTagOfData(list, this)
    }
  },
  created() {
    this.target.audienceData = this.target.audiences[0].audienceData
  }
}
</script>

<style lang="scss" scoped>
.col-flex {
  min-height: 32px;
  display: flex;
  align-items: center;
}
</style>
